import { useCallback, type VoidFunctionComponent } from 'react';

import ModalDeleteDependency from '../../dependencies/ModalDeleteDependency';

export type DependencyToRemove = {
  locator: string,
  project: {
    title: string;
  };
  manual: boolean;
};

/**
 * @param {string} userRevisionLocator - the user project; (aka parent revision)
 * @param {DependencyToRemove | null} dependencyToRemove - the dependency to delete/ignore
 * @param {(dependency: DependencyToRemove | null) => void} setDependencyToRemove - setter for dependency to delete/ignore
 * @param {(locator: string) => void} onRemoveProjectDependency - callback for when dependency is deleted/ignored
 */
type Props = {
  userRevisionLocator: string;
  dependencyToRemove: DependencyToRemove | null;
  setDependencyToRemove: (dependency: DependencyToRemove | null) => void;
  onRemoveProjectDependency: (locator: string) => void;
};

const RemoveDependency: VoidFunctionComponent<Props> = ({
  userRevisionLocator,
  dependencyToRemove: revisionToRemove,
  setDependencyToRemove,
  onRemoveProjectDependency,
}) => {
  const onClose = useCallback(() => {
    // Reset the dependency locator to hide the modal
    setDependencyToRemove(null);
  }, [setDependencyToRemove]);

  if (!revisionToRemove) {
    return null;
  }

  return (
    <ModalDeleteDependency
      parent_locator={userRevisionLocator}
      revision={revisionToRemove}
      onIgnoreDependency={onRemoveProjectDependency}
      onDeleteDependency={onRemoveProjectDependency}
      onProjectChange={onClose}
      show={revisionToRemove != null}
      onHide={onClose}
    />
  );
};

export default RemoveDependency;
